<template>
<div>
   <Top/>
      
   <!-- content starts here -->
   <Content @onformsubmit="onFormSubmit($event)" v-show="stepone" :formdata="formdata"/>
   <!-- content ends  -->
   <Invoice v-show="steptwo" @previous="previous" :formdata="formdata" @saveandpay="saveAndPay($event)" :toggledisabled="toggledisabled"/>
   <!-- <Status/> -->
  <Footer/>
</div>
</template>

<script>
import Top from './components/Top.vue';
import Footer from './components/Footer.vue';
import Invoice from './Invoice.vue';
import Content from './Content.vue';
// import Status from './Status.vue';
export default {
  name: 'Mainform',
  components:{
      Top,
     Footer,
     Content,
     Invoice
    // Status
  },
  data() {
      return {
          toggledisabled:false,
          stepone:true,
          steptwo:false,
           titles:[         
            'Mr.',
            'Mrs.',
            'Ms.',
            'Rev.',
            'Rev. Sr.',
            'Dr.',
            'Prof',
            'Imam'
          ],
          degrees:[
              'PhD', 'MPhil', 'MSc','EMBA', 'MBA','MPH','MPA', 'MA', 'MBChB', 'BSc', 'BSc Admin', 'BA', 'BPH','Diploma', 'Certificate'
          ],
          formdata:{
              title:'',
              surname:'',
              othernames:'',
              firstname:'',
              email:'',
              phone:'',
              degree:[],
             daypasstype:[],
              ticket:'',
              yearofgraduation:'',
              hall:''

          },
          feename:'UG@70 Homecoming',
          request_from:'alumnirelation',
          clientref:''
      }
  },
  methods: {
      onFormSubmit($event){
         // console.log($event);
          this.formdata = $event;
          this.stepone = false;
          this.steptwo = true;
          this.toggledisabled = false;
      },
      previous(){
          this.steptwo = false;
          this.stepone = true;
      },
      joinme(arr){
        let r ='';
        for(var i=0;i<arr.length;i++){
            r+=arr[i]+',';
        }
        return r.substring(0, r.length - 1);
      },
      saveAndPay($event){
          this.toggledisabled = true;
          var _this = this;
            _this.formdata['feename'] = _this.feename;
            if(_this.formdata.degree instanceof Array){
                _this.formdata['degree1'] = _this.formdata.degree.join();
            }

             if(_this.formdata.daypasstype instanceof Array){
                _this.formdata['daypasstype1'] = _this.formdata.daypasstype.join();
            }
          
            _this.formdata['mode'] = $event.send;
            
            this.$http.post(this.itseconfig.baseurl+'/saveinformation',this.formdata).then(res=>{
               _this.toggledisabled = false;
                _this.clientref = res.data.id;
                _this.formdata['clientref'] = res.data.clientref;
                _this.formdata['amount'] = res.data.amount;
                _this.formdata['feename'] = _this.feename;
                _this.formdata['request_from'] = _this.request_from;
               
                localStorage.setItem('reguser',JSON.stringify(_this.formdata));
                  switch(_this.formdata['mode']){
                           case 'Pay With ExpressPay':
                               _this.toggledisabled = true;
                                this.$swal('Redirecting to payment portal... Please Wait');
                                this.$http.post(this.itseconfig.payment+'/checkout',this.formdata).then(res=>{
                                    if(res.data && res.data !==''){
                                         window.location.href=res.data;
                                    }else{
                                        this.$swal('Error','Payment Initializing failed..Please try again','error');
                                    }
                                }).catch();
                            break;
                           case 'Pay With Ego Ticket':
                               _this.toggledisabled = true;
                                window.location.href='https://egotickets.com/events/ug-70-alumni-homecoming';
                            break;
                           case 'Pay Ticket With Short Code':
                               this.$swal('Info','Pay by Dialing *713*33*98# on your phone to make payment','info');
                            break;
                          case 'Buy Ticket By Calling Us':
                               this.$swal('Info','Pay Directly into our Office Mobile Money Numbers (+233 277 018888, +233 555 707070, +233 548707070) or buy tickets by calling those numbers.','info');
                            break;
                        default:
                            this.$swal('Alert','Please Choose a Payment Method','info');
                            break;
                 }  

           }).catch(()=>{
               this.toggledisabled = false;
               //console.log('errror');
           });
      }
  },
  mounted() {
      //console.log(localStorage.getItem('reguser'));
      if(localStorage.getItem('reguser')){
         
      if(localStorage.getItem('reguser') !== 'undefined' || localStorage.getItem('reguser')!==null){
          //console.log(JSON.parse(localStorage.getItem('reguser')));
          this.formdata = JSON.parse(localStorage.getItem('reguser'));
          // console.log(this.formdata);
          //if(this.formdata.degree){
            //   if(this.formdata.degree===""){
            //       this.formdata.degree = [];
            //   }else{
            //   this.formdata.degree = this.formdata.degree.split(',');
            //   }
             
        // }


         // if(this.formdata.daypasstype){
            //   if(this.formdata.daypasstype===""){
            //       this.formdata.daypasstype = [];
            //   }else{
            //        this.formdata.daypasstype = this.formdata.daypasstype.split(',');
            //   }    
          //}
      }

      }
    
      this.toggledisabled = false;
  },
}
</script>
<style scoped>

</style>
